import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import FinishedBanner from './FinishedBanner.jsx';

const PickedPrizeBanner = () => {
  const { t } = useTranslation('posts');

  return (
    <FinishedBanner
      header={t('prizeBanner.winnerSelected')}
      description={t('prizeBanner.winnerSelectedDescription')}
      btnIcon={<EditIcon />}
      btnText={t('prizeBanner.editWinners')}
    />
  );
};

export default PickedPrizeBanner;

const EditIcon = styled.i.attrs({
  className: 'fa-solid fa-arrows-rotate fa-xl fa-flip-horizontal',
})`
  margin-right: 5px;
`;
